import { Box, Button, Card, Stack, TextField, Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import EditBookingModal from "./editBookingModal";
import CompleteBooking from "./completeBooking";
import EmailIcon from "@mui/icons-material/Email";
import PrintIcon from "@mui/icons-material/Print";
import { useState } from "react";
import PrintModal from "./printModal";
import InvitationCard from "./invitationCard";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import LocalPizzaIcon from "@mui/icons-material/LocalPizza";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { convertTo12HourTimeCompact } from "../../../util/general/convertTo12HourTimeCompact";
import BadgeIcon from "@mui/icons-material/Badge";
import CompleteParty from "./completeParty";
import CancelBooking from "./cancelBooking";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";

const BookedEvent = (props) => {
  const dates =
    props.completedBookings.length === 0
      ? ["All"]
      : props.completedBookings
          .map((e) => e.bookingDetail.party_date)
          .filter((value, index, self) => self.indexOf(value) === index)
          .sort((a, b) => a.localeCompare(b));

  const [printModal, setPrintModal] = useState(false);
  const [printData, setPrintData] = useState([]);
  const [invtCardModal, setInvtCardModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState("Upcoming");
  const [filterName, setFilterName] = useState("");

  const toRenderBooking =
    props.completedBookings.length === 0 ? (
      <>No Pending Bookings</>
    ) : (
      <Stack sx={{ maxWidth: 800 }}>
        {props.completedBookings
          .sort((a, b) =>
            `${a.bookingDetail.party_date}${a.bookingDetail.party_time}`.localeCompare(
              `${b.bookingDetail.party_date}${b.bookingDetail.party_time}`
            )
          )
          .filter((item) =>
            selectedDate == "All"
              ? dates.includes(item.bookingDetail.party_date)
              : selectedDate === "Upcoming"
              ? item.bookingDetail.party_date === dates[0]
              : item.bookingDetail.party_date === selectedDate
          )
          .filter((item) =>
            `${item.bookingDetail.celebrant.toLowerCase()}`.includes(
              filterName.toLowerCase()
            )
          )
          .map((e) => (
            <Card
              key={e._id}
              variant="outlined"
              sx={{
                maxWidth: 400,
                marginTop: "30px",
                borderWidth: "2px",
                padding: "10px",
                paddingTop: "0",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.112)",
                "&:hover": {
                  boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.187)",
                },
              }}
            >
              <Stack direction="column" justifyContent="space-between">
                <Box>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    sx={{
                      width: "100%",
                      //   bgcolor: "#0aa014",
                      fontSize: "18px",
                      //   color: "white",
                      textAlign: "right",
                      fontWeight: "600",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #69676a7f",
                    }}
                  >
                    <Box>
                      <span style={{ color: "#b68014" }}>
                        {e.bookingDetail.party_date.slice(5)}{" "}
                      </span>{" "}
                      {convertTo12HourTimeCompact(e.bookingDetail.party_time)}
                      {/* <ChangeDateTime
                        eventData={e}
                        reFreshData={props.reFreshData}
                      /> */}
                    </Box>
                    <Box sx={{ ml: "10px" }}>
                      Booking#:{" "}
                      <span style={{ color: "green" }}>{e._id.slice(-6)} </span>
                    </Box>
                  </Stack>
                  <Typography
                    Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                      fontWeight: "600",
                      textAlign: "center",
                      paddingY: "10px",
                      fontSize: "20px",
                    }}
                  >
                    {e.bookingDetail.celebrant}
                    {e.bookingDetail.gender === "Boy" && (
                      <MaleIcon sx={{ color: "#1e78d1" }} />
                    )}
                    {e.bookingDetail.gender === "Girl" && (
                      <FemaleIcon sx={{ color: "#e2589d" }} />
                    )}
                  </Typography>
                  <Stack direction="row" spacing={3}>
                    <Box>
                      <Typography
                        Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{
                          fontSize: "16px",
                          width: "fit-content",
                          color: "white",
                          padding: "5px",
                          borderRadius: "5px",

                          bgcolor:
                            e.package.package_name === "Giant Room" ||
                            e.package.package_name === "Giant Party"
                              ? "blue"
                              : e.package.package_name === "Large Room" ||
                                e.package.package_name === "Large Party"
                              ? "orange"
                              : e.package.package_name === "Medium Room" ||
                                e.package.package_name === "Medium Party"
                              ? "green"
                              : "purple",
                        }}
                      >
                        {e.package.package_name}
                      </Typography>

                      <Stack
                        direction="row"
                        sx={{ fontSize: "16px", mt: "15px" }}
                      >
                        <EscalatorWarningIcon sx={{ mr: "10px" }} />{" "}
                        {e.bookingDetail.num_kid}/{e.bookingDetail.num_adult}
                      </Stack>
                      <Stack
                        direction="row"
                        sx={{ fontSize: "16px", mt: "5px" }}
                      >
                        <LocalPizzaIcon sx={{ mr: "10px" }} />{" "}
                        {e.bookingDetail.cheese_pizza}C{" "}
                        {e.bookingDetail.pepperoni_pizza}P{" "}
                        {e.bookingDetail.veggie_pizza}V
                      </Stack>
                      <Stack
                        direction="row"
                        sx={{ fontSize: "16px", mt: "5px", mb: "15px" }}
                      >
                        <CardGiftcardIcon sx={{ mr: "10px" }} />{" "}
                        {e.package.free_return_pass} return pass
                      </Stack>
                    </Box>
                    <Box>
                      <Typography Typography variant="subtitle2" gutterBottom>
                        Bg board: {e.bookingDetail.theme}
                      </Typography>
                      <Typography Typography variant="subtitle2" gutterBottom>
                        Gummy dragon:{" "}
                        {e.bookingDetail.upgrade_gummy_dragon ? "yes" : "no"}
                      </Typography>
                      <Typography Typography variant="subtitle2" gutterBottom>
                        Luxury package:{" "}
                        {e.bookingDetail.upgrade_luxury_package ? "yes" : "no"}
                      </Typography>
                      <Typography Typography variant="subtitle2" gutterBottom>
                        Unlimted play time:{" "}
                        {e.bookingDetail.upgrade_unlimited_playtime
                          ? "yes"
                          : "no"}
                      </Typography>
                      <Typography Typography variant="subtitle2" gutterBottom>
                        Outside food:{" "}
                        {e.bookingDetail.bring_own_food ? "yes" : "no"}
                      </Typography>
                    </Box>
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    sx={{ fontSize: "14px", mt: "5px", mb: "15px" }}
                  >
                    <BadgeIcon></BadgeIcon>
                    Booking Staff :
                    <Typography
                      sx={{
                        width: "fit-content",
                        padding: "0.5px",
                        marginLeft: "5px",
                        bgcolor: "orange",
                        borderRadius: "5px",
                      }}
                    >
                      {e.bookingDetail.assigned_employee}
                    </Typography>
                  </Stack>

                  <Stack
                    direction="row"
                    alignItems="center"
                    sx={{ fontSize: "14px", mt: "5px", mb: "15px", ml: "20px" }}
                  >
                    Assigned Staff :
                    <Typography
                      sx={{
                        width: "fit-content",
                        padding: "0.5px",
                        marginLeft: "5px",
                        bgcolor: "orange",
                        borderRadius: "5px",
                      }}
                    >
                      {e.bookingDetail.serve_party_employee}
                    </Typography>
                  </Stack>
                  <Typography Typography variant="subtitle2" gutterBottom>
                    {e.bookingDetail.special_request}
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  startIcon={<PrintIcon />}
                  sx={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    minWidth: "150px",
                    maxWidth: "180px",
                  }}
                  onClick={() => {
                    setPrintModal(true);
                    setPrintData(e);
                  }}
                >
                  Print / Detail
                </Button>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography component="span">More actions</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {/* <TextConfirmation eventData={e} /> */}

                    <Stack direction="row" flexWrap="wrap" gap="10px">
                      <EditBookingModal
                        eventData={e}
                        reFreshData={props.reFreshData}
                      />

                      <Button
                        variant="contained"
                        startIcon={<EmailIcon />}
                        sx={{
                          marginTop: "20px",
                          marginBottom: "20px",
                          minWidth: "140px",
                        }}
                        onClick={() => {
                          setInvtCardModal(true);
                          setPrintData(e);
                        }}
                      >
                        Invitation Card
                      </Button>
                      <CancelBooking
                        eventData={e}
                        reFreshData={props.reFreshData}
                      />

                      <CompleteParty
                        eventData={e}
                        reFreshData={props.reFreshData}
                      />
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              </Stack>
            </Card>
          ))}
      </Stack>
    );
  return (
    <Stack sx={{ width: "100%", height: `calc(100vh - 260px)` }}>
      <div>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="demo-simple-select-standard-label">
            Party Date
          </InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={selectedDate}
            onChange={(e) => {
              setSelectedDate(e.target.value);
            }}
            label="Age"
          >
            <MenuItem value={"Upcoming"}>{"Upcoming"}</MenuItem>

            <MenuItem value={"All"}>{"All"}</MenuItem>

            {dates.map((e) => (
              <MenuItem key={e} value={e}>
                {e.slice(5)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="demo-simple-select-standard-label"></InputLabel>
          <TextField
            label="Child"
            variant="standard"
            value={filterName}
            onChange={(e) => {
              setFilterName(e.target.value);
              if (e.target.value.length > 0) {
                setSelectedDate("All");
              } else setSelectedDate("Upcoming");
            }}
          ></TextField>
        </FormControl>
      </div>
      {invtCardModal && (
        <InvitationCard
          inviteInfo={printData}
          onClose={() => setInvtCardModal(false)}
        />
      )}

      {printModal && (
        <PrintModal
          closeModal={() => setPrintModal(false)}
          data={printData}
        ></PrintModal>
      )}
      <Box
        sx={{
          height: `calc(100vh - 280px)`,
          overflowY: "auto",
          borderTop: "2px solid #a4a5d8",
          marginTop: "5px",
        }}
      >
        {toRenderBooking}
      </Box>
    </Stack>
  );
};

export default BookedEvent;
